import Shipping from '../src/Shipping';
export default Shipping;
